// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import $ from 'jquery'
import router from './router'
import vux from './vux'
import store from "./store"; //导入store
import axios from './axios';

import ElementUI from 'element-ui';

// 公共方法
import common from './assets/js/common.js';
Vue.prototype.common = common;

// 从config.js中取出的全局变量
import {
  baseUrl,
  mediaUrl
} from '../static/config.js'
window.baseUrl = baseUrl
window.mediaUrl = mediaUrl

// import 'element-ui/lib/theme-chalk/index.css'
// 在html页面 引入cdn

Vue.config.productionTip = false

Vue.use(ElementUI);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  axios,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js